import type * as THREE from 'three';

/**
 * Engine camera registry (DOM-overlay bridge).
 *
 * DOM overlays rendered OUTSIDE the R3F canvas (the bottom-right viewport
 * axes gizmo) still need the live camera to mirror the view orientation.
 * EngineViewport mounts a registry mount inside the Canvas that publishes
 * the active camera here; overlays read it on 'yap:camera-changed' ticks
 * (rendering/cameraTick). The BIM/sketch shells reuse the same engine, so
 * one slot is enough — only one engine viewport is mounted per route.
 */
let activeEngineCamera: THREE.Camera | null = null;

export function setActiveEngineCamera(camera: THREE.Camera | null): void {
    activeEngineCamera = camera;
}

export function getActiveEngineCamera(): THREE.Camera | null {
    return activeEngineCamera;
}
